import { Stack, Typography } from "@mui/material";

const QuotesList = () => {
  return (
    <Stack
      spacing={1}
      sx={{
        marginTop: 1,
        height: "100%",
      }}
    >
      <Typography>Lista wycen nie jest dostępna. Kliknij w bezpośredni link do wyceny otrzymany w e-mailu.</Typography>
    </Stack>
  );
};

export default QuotesList;
